var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-form",
    {
      ref: "form",
      model: {
        value: _vm.valid,
        callback: function($$v) {
          _vm.valid = $$v
        },
        expression: "valid"
      }
    },
    [
      _c(
        "div",
        { staticClass: "section-label" },
        [
          _c(
            "v-icon",
            { staticClass: "mr-1 primary--text", attrs: { small: "" } },
            [_vm._v("mdi-map-marker-outline")]
          ),
          _c(
            "span",
            { staticClass: "overline primary--text font-weight-bold" },
            [_vm._v("Identificação")]
          )
        ],
        1
      ),
      _c("v-divider", { staticClass: "mb-3" }),
      _c(
        "v-row",
        { attrs: { dense: "" } },
        [
          _c(
            "v-col",
            { attrs: { cols: "12", sm: "4", md: "3" } },
            [
              _c("v-text-field", {
                attrs: {
                  dense: "",
                  outlined: "",
                  label: "UF",
                  "prepend-inner-icon": "mdi-map",
                  disabled: "",
                  "hide-details": ""
                },
                model: {
                  value: _vm.comarca.cd_uf,
                  callback: function($$v) {
                    _vm.$set(_vm.comarca, "cd_uf", $$v)
                  },
                  expression: "comarca.cd_uf"
                }
              })
            ],
            1
          ),
          _c(
            "v-col",
            { attrs: { cols: "12", sm: "4", md: "3" } },
            [
              _c("v-text-field", {
                attrs: {
                  dense: "",
                  outlined: "",
                  label: "Código da Comarca",
                  "prepend-inner-icon": "mdi-identifier",
                  "hide-details": ""
                },
                model: {
                  value: _vm.comarca.cd_ibge_comarca,
                  callback: function($$v) {
                    _vm.$set(_vm.comarca, "cd_ibge_comarca", $$v)
                  },
                  expression: "comarca.cd_ibge_comarca"
                }
              })
            ],
            1
          ),
          _c(
            "v-col",
            { attrs: { cols: "12", sm: "4", md: "6" } },
            [
              _c("v-text-field", {
                attrs: {
                  dense: "",
                  outlined: "",
                  label: "Nome da Comarca",
                  "prepend-inner-icon": "mdi-city",
                  "hide-details": ""
                },
                model: {
                  value: _vm.comarca.nm_comarca,
                  callback: function($$v) {
                    _vm.$set(_vm.comarca, "nm_comarca", $$v)
                  },
                  expression: "comarca.nm_comarca"
                }
              })
            ],
            1
          ),
          _c(
            "v-col",
            { attrs: { cols: "12", sm: "4", md: "3" } },
            [
              _c("v-text-field", {
                staticClass: "mt-2",
                attrs: {
                  dense: "",
                  outlined: "",
                  label: "Código do Município",
                  "prepend-inner-icon": "mdi-identifier",
                  disabled: "",
                  "hide-details": ""
                },
                model: {
                  value: _vm.comarca.cd_ibge_municipio,
                  callback: function($$v) {
                    _vm.$set(_vm.comarca, "cd_ibge_municipio", $$v)
                  },
                  expression: "comarca.cd_ibge_municipio"
                }
              })
            ],
            1
          ),
          _c(
            "v-col",
            { attrs: { cols: "12", sm: "8", md: "9" } },
            [
              _c("v-text-field", {
                staticClass: "mt-2",
                attrs: {
                  dense: "",
                  outlined: "",
                  label: "Nome do Município",
                  "prepend-inner-icon": "mdi-home-city-outline",
                  disabled: "",
                  "hide-details": ""
                },
                model: {
                  value: _vm.comarca.nm_municipio,
                  callback: function($$v) {
                    _vm.$set(_vm.comarca, "nm_municipio", $$v)
                  },
                  expression: "comarca.nm_municipio"
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "section-label mt-4" },
        [
          _c(
            "v-icon",
            { staticClass: "mr-1 primary--text", attrs: { small: "" } },
            [_vm._v("mdi-map-marker-radius-outline")]
          ),
          _c(
            "span",
            { staticClass: "overline primary--text font-weight-bold" },
            [_vm._v("Faixa de CEP")]
          )
        ],
        1
      ),
      _c("v-divider", { staticClass: "mb-3" }),
      _c(
        "v-row",
        { attrs: { dense: "" } },
        [
          _c(
            "v-col",
            { attrs: { cols: "12", sm: "6" } },
            [
              _c("v-text-field", {
                attrs: {
                  dense: "",
                  outlined: "",
                  label: "CEP Inicial",
                  "prepend-inner-icon": "mdi-map-marker-left-outline",
                  "hide-details": ""
                },
                model: {
                  value: _vm.comarca.cd_cep_abrangente_inicio,
                  callback: function($$v) {
                    _vm.$set(_vm.comarca, "cd_cep_abrangente_inicio", $$v)
                  },
                  expression: "comarca.cd_cep_abrangente_inicio"
                }
              })
            ],
            1
          ),
          _c(
            "v-col",
            { attrs: { cols: "12", sm: "6" } },
            [
              _c("v-text-field", {
                attrs: {
                  dense: "",
                  outlined: "",
                  label: "CEP Final",
                  "prepend-inner-icon": "mdi-map-marker-right-outline",
                  "hide-details": ""
                },
                model: {
                  value: _vm.comarca.cd_cep_abrangente_fim,
                  callback: function($$v) {
                    _vm.$set(_vm.comarca, "cd_cep_abrangente_fim", $$v)
                  },
                  expression: "comarca.cd_cep_abrangente_fim"
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "section-label mt-4" },
        [
          _c(
            "v-icon",
            { staticClass: "mr-1 primary--text", attrs: { small: "" } },
            [_vm._v("mdi-cog-outline")]
          ),
          _c(
            "span",
            { staticClass: "overline primary--text font-weight-bold" },
            [_vm._v("Configurações")]
          )
        ],
        1
      ),
      _c("v-divider", { staticClass: "mb-3" }),
      _c(
        "v-row",
        { attrs: { dense: "", align: "center" } },
        [
          _c(
            "v-col",
            { attrs: { cols: "12", sm: "4", md: "4" } },
            [
              _c("v-text-field", {
                directives: [
                  {
                    name: "maska",
                    rawName: "v-maska",
                    value: "####",
                    expression: "'####'"
                  }
                ],
                attrs: {
                  dense: "",
                  outlined: "",
                  label: "Limite Diário de Envios",
                  "prepend-inner-icon": "mdi-counter",
                  oninput: "if(this.value < 0) this.value = 0;",
                  "hide-details": ""
                },
                on: {
                  focus: function($event) {
                    return _vm.focusInput($event)
                  }
                },
                scopedSlots: _vm._u([
                  {
                    key: "append",
                    fn: function() {
                      return [
                        _c(
                          "div",
                          {
                            staticClass: "d-flex flex-column",
                            staticStyle: { gap: "2px", "margin-top": "-4px" }
                          },
                          [
                            _c(
                              "v-btn",
                              {
                                attrs: {
                                  icon: "",
                                  "x-small": "",
                                  color: "primary",
                                  tabindex: "-1"
                                },
                                on: { click: _vm.aumentarLimite }
                              },
                              [
                                _c("v-icon", { attrs: { "x-small": "" } }, [
                                  _vm._v("mdi-chevron-up")
                                ])
                              ],
                              1
                            ),
                            _c(
                              "v-btn",
                              {
                                attrs: {
                                  icon: "",
                                  "x-small": "",
                                  color: "primary",
                                  tabindex: "-1"
                                },
                                on: { click: _vm.diminuirlimite }
                              },
                              [
                                _c("v-icon", { attrs: { "x-small": "" } }, [
                                  _vm._v("mdi-chevron-down")
                                ])
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ]
                    },
                    proxy: true
                  }
                ]),
                model: {
                  value: _vm.comarca.ds_limite_diario,
                  callback: function($$v) {
                    _vm.$set(_vm.comarca, "ds_limite_diario", $$v)
                  },
                  expression: "comarca.ds_limite_diario"
                }
              })
            ],
            1
          ),
          _c(
            "v-col",
            {
              staticClass: "d-flex align-center pl-4",
              attrs: { cols: "12", sm: "4", md: "4" }
            },
            [
              _c("v-switch", {
                staticClass: "mt-0",
                attrs: {
                  color: "success",
                  inset: "",
                  dense: "",
                  "hide-details": "",
                  "data-cy": "btnStatusComarca"
                },
                scopedSlots: _vm._u([
                  {
                    key: "label",
                    fn: function() {
                      return [
                        _c("span", { staticClass: "body-2" }, [
                          _vm._v(" Status: "),
                          _c(
                            "strong",
                            {
                              class: _vm.comarca.st_ativo
                                ? "success--text"
                                : "error--text"
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.comarca.st_ativo ? "Ativo" : "Inativo"
                                  ) +
                                  " "
                              )
                            ]
                          )
                        ])
                      ]
                    },
                    proxy: true
                  }
                ]),
                model: {
                  value: _vm.comarca.st_ativo,
                  callback: function($$v) {
                    _vm.$set(_vm.comarca, "st_ativo", $$v)
                  },
                  expression: "comarca.st_ativo"
                }
              })
            ],
            1
          ),
          _c(
            "v-col",
            {
              staticClass: "d-flex align-center pl-4",
              attrs: { cols: "12", sm: "4", md: "4" }
            },
            [
              _c("v-switch", {
                staticClass: "mt-0",
                attrs: {
                  color: "success",
                  inset: "",
                  dense: "",
                  "hide-details": ""
                },
                scopedSlots: _vm._u([
                  {
                    key: "label",
                    fn: function() {
                      return [
                        _c("span", { staticClass: "body-2" }, [
                          _vm._v(" Requer Endosso: "),
                          _c(
                            "strong",
                            {
                              class: _vm.comarca.requer_endosso
                                ? "success--text"
                                : "grey--text"
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.comarca.requer_endosso ? "Sim" : "Não"
                                  ) +
                                  " "
                              )
                            ]
                          )
                        ])
                      ]
                    },
                    proxy: true
                  }
                ]),
                model: {
                  value: _vm.comarca.requer_endosso,
                  callback: function($$v) {
                    _vm.$set(_vm.comarca, "requer_endosso", $$v)
                  },
                  expression: "comarca.requer_endosso"
                }
              }),
              _c(
                "v-tooltip",
                {
                  attrs: { bottom: "" },
                  scopedSlots: _vm._u([
                    {
                      key: "activator",
                      fn: function({ on, attrs }) {
                        return [
                          _c(
                            "v-icon",
                            _vm._g(
                              _vm._b(
                                {
                                  staticClass: "ml-2 grey--text",
                                  attrs: { small: "" }
                                },
                                "v-icon",
                                attrs,
                                false
                              ),
                              on
                            ),
                            [_vm._v("help")]
                          )
                        ]
                      }
                    }
                  ])
                },
                [
                  _c("span", [
                    _vm._v(
                      "Selecione para definir se a comarca requer endosso ou não"
                    )
                  ])
                ]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }